import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  clear() {
    this.element.querySelectorAll('input').forEach((input) => {
      input.value = ''
    })
    this.element.querySelectorAll('select').forEach((select) => {
      select.value = ''
    })
  }
}
